// extracted by mini-css-extract-plugin
export default {"data":"MetaDataContent_data__EbS0Q","head":"MetaDataContent_head__BD3Tx","value":"MetaDataContent_value__gUDF3","warning":"MetaDataContent_warning__pmM0O"};